import { render, staticRenderFns } from "./YouTube.vue?vue&type=template&id=4e3d521c&scoped=true&"
import script from "./YouTube.vue?vue&type=script&lang=js&"
export * from "./YouTube.vue?vue&type=script&lang=js&"
import style0 from "./YouTube.vue?vue&type=style&index=0&id=4e3d521c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3d521c",
  null
  
)

export default component.exports